module.exports = __webpack_public_path__ + "803b456f924b0ee5209381e50a0512a3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners/banner-farm.png
// module id = 3438
// module chunks = 0